import * as z from 'zod';

import { CompanyReportDownloadId, CompanyReportId, UserId } from './BrandedIds';
import { zodDateOrString } from './utils';

const CompanyReportDownload = z.object({
  id: CompanyReportDownloadId,
  companyReportId: CompanyReportId,
  userId: UserId,
  userName: z.string().optional(),
  userEmail: z.string(),
  timestamp: zodDateOrString,
});
export type CompanyReportDownload = z.infer<typeof CompanyReportDownload>;
